import React from "react";
import {
  Autocomplete,
  TextField,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import { CalendarSvg } from "@/src/Asset";

const AutocompleteCountry = ({
  field,
  formData,
  filteredTopCountryData,
  setFormData,
  intakeYears,
  disabled,
  source,
}: any) => {
  return (
    <>
      {source !== "college-review" && (
        <div className="">
          <FormControl fullWidth>
            <div className="flex items-center gap-x-2 px-1.5 mb-1">
              <CalendarSvg className="w-4" />
              <label
                htmlFor="intake-year"
                id="intake-year"
                className="text-sm lg:text-base"
              >
                Intake Year
              </label>
            </div>

            <Select
              labelId="intake-year"
              value={formData.year || "select-year"}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  year: e.target.value === "select-year" ? "" : e.target.value,
                })
              }
              required
              className="text-xs"
              sx={{
                "& .MuiSelect-select": {
                  fontSize: "0.75rem",
                  padding: "0 8px",
                },
                "& .MuiInputBase-input": {
                  textAlign: "start",
                  fontSize: "0.80rem",
                  padding: "0 16px",
                  color: "black",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderWidth: "1px",
                },
                minHeight: "32px",
              }}
            >
              <MenuItem value="select-year" disabled>
                Select Intake Year
              </MenuItem>
              {intakeYears?.map((year: any) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      )}
      <div className="font-sans space-y-1">
        <div className="font-inter font-medium text-xs text-[#404D61] px-1 flex items-center gap-x-2 mb-1">
          {field?.icon}
          <label className="text-sm lg:text-base">{field.label}</label>
        </div>
        <Autocomplete
          multiple
          disabled={disabled}
          size="small"
          value={
            formData.country?.length
              ? filteredTopCountryData?.filter((country: any) =>
                  formData.country.includes(country.id)
                )
              : []
          }
          onChange={(event, newValue) => {
            setFormData({
              ...formData,
              country: newValue.map((country: any) => country.id),
            });
          }}
          options={filteredTopCountryData || []}
          getOptionLabel={(country) => country.country_name || ""}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={field.placeholder}
              className="w-full text-xs text-gray-600"
              InputProps={{
                ...params.InputProps,
                sx: {
                  fontSize: "0.875rem",
                  // height: "32px",
                },
              }}
            />
          )}
          ListboxProps={{
            style: {
              maxHeight: "220px",
              overflow: "auto",
              fontSize: "0.75rem",
            },
          }}
          sx={{
            width: "100%",
            "& .MuiAutocomplete-option": {
              py: 0.5,
              fontSize: "0.875rem",
            },
            "& .MuiAutocomplete-input": {
              px: 1,
              py: 0.5,
              fontSize: "0.875rem",
            },
          }}
        />
      </div>
    </>
  );
};

export default AutocompleteCountry;
